import type { EntryPoint, EntryPointComponent } from 'react-relay';
/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import SettingsContainerContentQuery, {
	type SettingsContainerContentQuery as SettingsContainerContentQueryType,
} from '@jira/servicedesk__queues-config/src/__generated__/SettingsContainerContentQuery.graphql.ts';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JiraServicedeskQueueAri } from '@atlassian/ari/jira-servicedesk/queue';
import type { Match, Route } from '@atlassian/react-resource-router';

type Queries = {
	SettingsContainerContentQuery: SettingsContainerContentQueryType;
};

const NAVIGATION_ITEMS_PAGE_SIZE = 75;

type QueuesConfigEntrypointComponent = EntryPointComponent<
	Queries,
	{},
	{},
	{
		query: {
			config?: string;
		};
		match: Match;
		route: Route;
	}
>;

export const queuesConfigEntrypoint: EntryPoint<
	QueuesConfigEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<QueuesConfigEntrypointComponent>(
		/* webpackChunkName: "async-servicedesk-queues-config", jiraSpaEntry: "async-servicedesk-queues-config" */ './index.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: { match, query, route },
		tenantContext: { activationId, cloudId },
	}: EntryPointRouteParams) => {
		const queueId = match.params.queueId;
		let { projectKey } = getProjectKeyId(match, query);
		projectKey = projectKey ?? '';

		const queueAri = queueId
			? JiraServicedeskQueueAri.create({
					siteId: cloudId,
					queueId: queueId || '',
					activationId,
				}).toString()
			: '';

		const input = queueAri ? { scopeId: queueAri } : { projectKeyQuery: { cloudId, projectKey } };
		return {
			queries: {
				SettingsContainerContentQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters: SettingsContainerContentQuery,
					variables: {
						input,
						first: NAVIGATION_ITEMS_PAGE_SIZE,
					},
				},
			},
			extraProps: { query, match, route },
		};
	},
});
